import React from 'react';
import {withNamespaces} from 'react-i18next';

const DomesticDetail = ({ request,t }) => (
  <div>
    <div className="content table-responsive table-full-width">
      <table className="table table-hover table-bordered">
        <thead>
          <tr className="table-info">
            <td colSpan="2">
              <b id="costDetailDomestic">
                {t("domestic")}
              </b>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {t("destinationCity")}
            </td>
            <td id="DomesticDetailProvinceName">
              {request.domestic.provinces.map((province, index) => (
                <span key={province.value}>
                  {province.label}
                  {' '}
                  {index !== request.domestic.provinces.length - 1 ? ',' : null}
                  {' '}

                </span>
              ))}
            </td>
          </tr>
          <tr>
            <td>
              {t("reasonForTravel")}
            </td>
            <td id="DomesticDetailTravelReasons">
              {request.travelReasons.map((reason, index) => (
                <span key={reason.value}>
                  {reason.label}
                  {index !== request.travelReasons.length - 1 ? ',' : null}
                </span>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default withNamespaces()(DomesticDetail);



// WEBPACK FOOTER //
// ./src/components/domestic/detail/index.js